import React, { Children } from 'react';
import { motion } from 'framer-motion';
export function PainPointsSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="w-full py-20 px-4 sm:px-6 lg:px-8 bg-[#0a0505]" data-id="element-193">
      <div className="max-w-4xl mx-auto" data-id="element-194">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} className="flex flex-col items-center" data-id="element-195">
          <motion.h2 variants={itemVariants} className="text-2xl sm:text-3xl md:text-4xl font-bold text-white text-center mb-6 leading-tight" data-id="element-196">
            ¿Seguís rechazado por los bancos por una deuda que quizás ya ni
            existe legalmente?
          </motion.h2>

          <motion.p variants={itemVariants} className="text-gray-400 text-center max-w-[720px] text-base sm:text-lg mb-4" data-id="element-197">
            Vivir con el Veraz manchado no es solo un problema financiero. Es
            una condena silenciosa que te bloquea en todos los aspectos de tu
            vida. Y lo peor es que la mayoría de las personas no sabe que tiene
            derechos legales concretos para salir de esa situación.
          </motion.p>

          <motion.p variants={itemVariants} className="text-brand-gold font-bold text-lg sm:text-xl text-center mb-12" data-id="element-198">
            No es culpa tuya. Es un sistema que te mantiene atrapado.
          </motion.p>

          <div className="w-full flex flex-col gap-4" data-id="element-199">
            <motion.div variants={itemVariants} className="bg-[#1a0505] border border-red-900/30 rounded-xl p-5 flex items-center gap-4 shadow-lg" data-id="element-200">
              <span className="text-red-500 text-2xl shrink-0" data-id="element-201">❌</span>
              <p className="text-white font-medium text-sm sm:text-base" data-id="element-202">
                Rechazos constantes sin explicación clara al pedir tarjetas o
                préstamos
              </p>
            </motion.div>

            <motion.div variants={itemVariants} className="bg-[#1a0505] border border-red-900/30 rounded-xl p-5 flex items-center gap-4 shadow-lg" data-id="element-203">
              <span className="text-red-500 text-2xl shrink-0" data-id="element-204">❌</span>
              <p className="text-white font-medium text-sm sm:text-base" data-id="element-205">
                Estudios de cobranza que te acosan con llamadas y mensajes
                amenazantes
              </p>
            </motion.div>

            <motion.div variants={itemVariants} className="bg-[#1a0505] border border-red-900/30 rounded-xl p-5 flex items-center gap-4 shadow-lg" data-id="element-206">
              <span className="text-red-500 text-2xl shrink-0" data-id="element-207">❌</span>
              <p className="text-white font-medium text-sm sm:text-base" data-id="element-208">
                Sensación de que tenés que pagar sí o sí para salir del problema
              </p>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}